import { Injectable } from '@angular/core';
import { HttpUtilityService } from 'src/app/core/services/http.utility.service';
import { RequestIssueDetails } from '../models/sar-request/request-issue/request-issue-details.model';
import { Observable } from 'rxjs';
import { requestIssueConst } from 'src/app/core/constants/request-Issue.const';
import { requestLineConst } from 'src/app/core/constants/request-line.const';
import { DeleteLineItemDto } from '../models/common/delete-line-item.model';
import { HttpHeaders } from '@angular/common/http';
import { AssignmentDetailsDto } from '../models/approval-details/assignment-detail.model';
import { EquipmentProperty } from '../models/common/equipment-property.model';
import { RecommendedStockingLocationDto } from '../../setup/models/stocking-location.model.ts/stocking-location.model';

@Injectable({
  providedIn: 'root'
})

export class RequestLineService {
  
  abuId: number = 32; // Australian Business Unit Id

  constructor(private httpUtilityService: HttpUtilityService) {
  }

  getActions(requestNumber: string, isAbu: boolean): Observable<RequestIssueDetails[]> {
    const buId = isAbu ? this.abuId : 0;
    const url = `${requestIssueConst.apiName}${requestIssueConst.getActions}/${buId}/${requestNumber}`;
    return this.httpUtilityService.getAll<RequestIssueDetails[]>(url);
  }

  UpdateLineAssignment(data: FormData) {
    return this.httpUtilityService.post(requestLineConst.apiName + requestLineConst.updateLineAssignment, data);

  }

  updateLineAssignmentForRejected(data: FormData) {
    return this.httpUtilityService.post(requestLineConst.apiName + requestLineConst.updateLineAssignmentForRejected, data);
  }

  DeleteLineItems(data: DeleteLineItemDto) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    }
    return this.httpUtilityService.delete(requestLineConst.apiName + requestLineConst.deleteLineItems, httpOptions);

  }

  getAssignmentDetailsByRequestLineId(requestLineId: number): Observable<AssignmentDetailsDto> {
    return this.httpUtilityService.getAll(requestLineConst.apiName + requestLineConst.getAssignmentDetailsByRequestLineId + `/${requestLineId}`);
  }

  getEquipment(phrase: string): Observable<string[]>{
    return this.httpUtilityService.getAll(requestLineConst.apiName + requestLineConst.getEquipmentNames + `?phrase=${phrase}`);
  }

  getEquipmentProperties(equipmentTags: string) : Observable<EquipmentProperty> {
    return this.httpUtilityService.get<EquipmentProperty>(requestLineConst.apiName + requestLineConst.getEquipmentProperty + `?equipmentTags=${equipmentTags}`);
  }

  getRecommendedStockingLocations(requestId: number) : Observable<RecommendedStockingLocationDto[]> {
    return this.httpUtilityService.get<RecommendedStockingLocationDto[]>(requestLineConst.apiName + requestLineConst.getRecommendedStockingLocations + `/${requestId}`);
  }

  getMatchingStockingLocationsInRequestLine(requestId: number, materialNumber: number) : Observable<RecommendedStockingLocationDto[]> {
    return this.httpUtilityService.get<RecommendedStockingLocationDto[]>(requestLineConst.apiName + requestLineConst.materialNumberInRequestLine + `?requestId=${requestId}&materialNumber=${materialNumber}`);
  }

  verifyIfMaterialNumberInRequestLine(requestId: number, requestIssueId: number, materialNumber: number) : Observable<boolean> {
    requestIssueId = requestIssueId === undefined ? -1 : requestIssueId;
    return this.httpUtilityService.get<boolean>(requestLineConst.apiName + requestLineConst.verifyIfMaterialNumberInRequestLine + `?requestId=${requestId}&requestIssueId=${requestIssueId}&materialNumber=${materialNumber}`);
  }
 
}
